
import  '@angular/compiler';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { CapacitorUpdater } from '@capgo/capacitor-updater';

import 'hammerjs'

CapacitorUpdater.notifyAppReady().then(() => {
  console.log('[CAPGO] App is ready, update check can be performed.');
}).catch((error) => {
  console.error('[CAPGO] Error notifying app ready:', error);
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
